// extracted by mini-css-extract-plugin
export var actionButton = "_io-0";
export var fileInput = "_io-2";
export var paperclip = "_io-1";